import { render, staticRenderFns } from "./LeccionB1.vue?vue&type=template&id=e237a4ee&"
import script from "./LeccionB1.vue?vue&type=script&lang=js&"
export * from "./LeccionB1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports